import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';

export const essityCatalogGraphOverridesModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [
    catalogGraphPlugin
      .getExtension('entity-card:catalog-graph/relations')
      .override({
        factory(originalFactory) {
          return originalFactory({
            params: {
              loader: async () => {
                return import('../components/cards').then(m => (
                  <m.EssityEntityRelationsGraphCard />
                ));
              },
            },
          });
        },
      }),
  ],
});
